export const AUDIO_FILE_MAX_SIZE = 200000000; // 200Mo
export const DEFAULT_SIZE_COVER = 300;
